$(window).scroll(function() {
  var scroll = $(window).scrollTop();
  if (scroll >= 180) {
    $("body .rd-header").addClass("sticky");
  }
  else{
    $("body .rd-header").removeClass("sticky");
  }
});

/* Code for Slick Slider - Multi Column - Redefine*/
$(document).ready(function(){
  $('.rd-twitterslide').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: '<button type="button" class="slick-button slick-prev">Previous</button>',
    nextArrow: '<button type="button" class="slick-button slick-next">Next</button>'
  });
  $('.aboutusbanner').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    speed: 2500,
    autoplay: true,
    autoplaySpeed: 4000,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-button slick-prev">Previous</button>',
    nextArrow: '<button type="button" class="slick-button slick-next">Next</button>'
  });
  $('.staticbanner').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    speed: 4000,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: '<button type="button" class="slick-button slick-prev">Previous</button>',
    nextArrow: '<button type="button" class="slick-button slick-next">Next</button>'
  });
  $('.slickbanner-main').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    speed: 4000,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: '<button type="button" class="slick-button slick-prev">Previous</button>',
    nextArrow: '<button type="button" class="slick-button slick-next">Next</button>'
  });
  $('.our-story-slick').slick({
    asNavFor: '.our-story-slick-nav',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
    fade: true,
    speed: 4000,
    autoplay: true,
    autoplaySpeed: 4000
  });
  $('.our-story-slick-nav').slick({
    asNavFor: '.our-story-slick',
    slidesToShow: 8,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    centerMode: true,
    adaptiveHeight: true,
    focusOnSelect: true,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 6,
      }
    },
    {
      breakpoint: 680,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
      }
    }
  ]
  });
});

